import { useList } from '../../../../../../api/react-query';

export function useGetFaceUrl(employeeId) {
  const { data, isLoading, isRefetching, isFetching, refetch } = useList(
    `employees/${employeeId}/face-photo-url`,
    {
      employeeId,
    },
    {
      enabled: !!employeeId, // don't fire the request until we actually have an id
    },
  );

  const photoUrl = data?.data?.photo_url ?? null;
  const hasPhoto = !!photoUrl;

  return {
    photoUrl,
    hasPhoto,
    isLoading: isLoading || isRefetching || isFetching,
    refetch,
  };
}
